module.exports={close:"Stäng",error:"Fel",info:"Information",success:"Lyckades",warning:"Varning"};